/* eslint-disable react/jsx-props-no-spreading */
import React, { Fragment, useCallback, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Carousel } from '@thd-olt-component-react/carousel';
import Favorite from '@thd-olt-component-react/save-to-favorites';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ProductPod } from '@thd-olt-component-react/product-pod';
import { Col, Row } from '@thd-olt-component-react/grid';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import Helpers from './DPDHelpers';
import * as analytics from './DPDAnalytics';
import { useDPD } from '../../../../hooks/useDPD';

import './DPD.scss';

function getWidth(defaultWidth = 0) {
  if (typeof document === 'undefined') return defaultWidth;

  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  );
}
/**
 * @group Components
 * Displays DPD component
 */

const DynamicProductDisplay = (props) => {
  const { channel } = useContext(ExperienceContext);
  const [startIndex, setStartIndex] = useState(0);
  const pageSize = 7;// channel === 'mobile' ? 3 : 6;
  const {
    skus = [],
    shopAllLink,
    categoryLabel,
    storeId,
    totalProducts = 0
  } = useDPD({
    ...props,
    pageSize,
    startIndex
  });

  const getLabel = useCallback(({ sortByName }) => {

    const displayLabel = Helpers.getDisplayLabel({ sortByName });
    const savingRegex = new RegExp('[A-Za-z]* Savings');
    let inLabel = '';
    if (displayLabel && categoryLabel) {
      inLabel = ' in ';
    }
    const curatedTitle = savingRegex.test(categoryLabel)
      ? categoryLabel
      : (
        <span>
          <span className="u__bold">{displayLabel}</span>{inLabel}{categoryLabel}
        </span>
      );
    return curatedTitle;
  }, [categoryLabel]);

  const {
    disableSwipeNavigation,
    // favorites,
    linkType,
    minDpdCount,
    // onFavoriteChange,
    opts,
    // parentNavParam,
    showArrows,
    showFavoritesCount,
    showDpdPod,
  } = props;
  const { Data = {} } = opts;
  const { sortBy = 'topsellers' } = Data;
  const isMobile = channel === 'mobile';
  const itemWidthPixelsMobile = 300;
  const dpdProps = {
    itemClass: isMobile ? 'mobile-fixed-item' : 'fixed-item',
    multiItem: false,
    showArrows: isMobile ? false : showArrows,
    disableSwipeNavigation: isMobile ? true : disableSwipeNavigation,
    fixedItem: true,
    itemWidthMobile: '80%',
    itemWidthPixelsMobile,
    totalItems: totalProducts,
    onNextClick: (itemspershift, nextPosition) => {
      if (nextPosition < totalProducts) {
        if (nextPosition >= (skus.length - 2) && skus.length < totalProducts) {
          setStartIndex(skus.length + 1);
        }
      }
    }
  };
  if (totalProducts < minDpdCount) {
    return null;
  }
  //
  // const favoriteCountMap = new Map();
  // favoritesCount.forEach((item) => {
  //   favoriteCountMap.set(item.itemId, item.favCount);
  // });

  const width = isMobile ? getWidth(375) - 30 : null;

  return (
    <QueryProvider dataSource="searchNav">
      <div className="dpd">
        {shopAllLink !== '' && (
          <div className="dpd__label">
            {getLabel({ sortByName: sortBy, categoryLabel })}
            <a className="dpd__shopall--link" href={shopAllLink}>
              Shop All
            </a>
          </div>
        )}
        {skus?.length > 0 && (
          <div className="dpd__carousel--wrapper" style={{ width }}>
            <Carousel {...dpdProps}>
              {skus.map((sku, index) => {

                let favoriteCount = 0;
                // if (favoriteCountMap.size && favoriteCountMap.has(Number(sku.itemId))) {
                //   favoriteCount = favoriteCountMap.get(Number(sku.itemId));
                // }

                // const dpdOpts = {
                //   anchorProductSku: parentNavParam ? `N-${parentNavParam}` : 'n/a',
                //   carouselName: Helpers.getDisplayLabel({ sortByName: sortBy }),
                //   displayPosition: index + 1,
                //   itemId: sku.itemId
                // };
                const { info = {}, identifiers = {} } = sku;
                const { badges = [] } = info;
                const { itemId } = identifiers;
                return (
                  <Fragment key={index}>
                    {isMobile
                      && (
                        <ProductPod
                          channel={channel}
                          itemId={itemId}
                          storeId={storeId}
                          className="grid mobile-horizontal"
                          showFavoritesCount={showFavoritesCount}
                          showDpdPod={showDpdPod}
                          pageType="dpd"
                          segment=""
                          showSwatchFavoriteCount
                          target={linkType}
                          mobilePodType="singleColumn"
                        >
                          {/* <div className="mobile-left-half">
                            <div className="product-pod__badge--wrapper">
                              <ProductPod.Badge badges={badges} />
                            </div>
                            <ProductPod.Image />
                            <ProductPod.Favorites position="topRight" showCircle onFavoriteChange={onFavoriteChange} />
                          </div>
                          <div className="mobile-right-half">
                            <div className={`product-pod--ie-fix ${channel}`}>
                              <ProductPod.Header target={linkType} />
                              <ProductPod.Variants mini />
                              <ProductPod.Rating />
                            </div>
                            <ProductPod.Price large={false} />
                          </div> */}
                        </ProductPod>
                      )}
                    {!isMobile
                      && (
                        <ProductPod
                          channel={channel}
                          showFavoritesCount={showFavoritesCount}
                          itemId={itemId}
                          storeId={storeId}
                          pageType="dpd"
                          segment=""
                          showSwatchFavoriteCount
                          target={linkType}
                          mobilePodType="singleColumn"
                          hideShippingInfo
                        >
                          {/* <div className="product-pod__badge--wrapper">
                            <ProductPod.Badge badges={badges} />
                          </div>
                          <ProductPod.Favorites position="topRight" showCircle onFavoriteChange={onFavoriteChange} />
                          <ProductPod.Image />
                          <div className={`product-pod--padding product-pod--ie-fix ${channel}`}>
                            <ProductPod.Variants mini />
                            <ProductPod.Header target={linkType} />
                            <Row>
                              <ProductPod.Rating />
                            </Row>
                            <ProductPod.Price large={false} />
                            <ProductPod.AddToCart
                              outline
                              hideDisabledATC
                              className="product-pod__add-to-cart"
                              checkGeneric
                            />
                          </div> */}
                        </ProductPod>
                      )}
                  </Fragment>
                );
              })}
            </Carousel>
          </div>
        )}
      </div>
    </QueryProvider>
  );
};

DynamicProductDisplay.propTypes = {
  channel: PropTypes.string,
  disableSwipeNavigation: PropTypes.bool,
  favorites: PropTypes.arrayOf(PropTypes.number),
  host: PropTypes.string,
  linkType: PropTypes.string,
  minDpdCount: PropTypes.number,
  onDPDChange: PropTypes.func,
  opts: PropTypes.shape({
    Data: PropTypes.shape({
      activeRefmts: PropTypes.bool,
      navParam: PropTypes.string,
      featuredRecords: PropTypes.instanceOf(Array),
      sortBy: PropTypes.string,
      sortOrder: PropTypes.string,
      colNumber: PropTypes.number,
      recordLimit: PropTypes.string,
      pageSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      isRefinement: PropTypes.bool,
      showNlpIcon: PropTypes.string,
      showAvailStatus: PropTypes.string,
      showRatings: PropTypes.string,
      sId: PropTypes.string,
      channel: PropTypes.string,
      navigationFilters: PropTypes.instanceOf(Array)
    }),
    type: PropTypes.string,
    isDynamicContent: PropTypes.bool
  }),
  parentNavParam: PropTypes.string,
  removeOOSSkus: PropTypes.bool,
  showArrows: PropTypes.bool,
  storeId: PropTypes.string,
  showFavoritesCount: PropTypes.bool,
  showDpdPod: PropTypes.bool
};

DynamicProductDisplay.defaultProps = {
  channel: 'desktop',
  disableSwipeNavigation: false,
  favorites: [],
  host: 'https://www.homedepot.com',
  linkType: '_self',
  minDpdCount: 4,
  onDPDChange: null,
  opts: {
    Data: {
      channel: 'desktop'
    }
  },
  parentNavParam: '',
  removeOOSSkus: false,
  showArrows: true,
  storeId: undefined,
  showFavoritesCount: false,
  showDpdPod: false
};

export default DynamicProductDisplay;
